import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { store } from 'src/store/store';
import { tryCatch } from 'src/utils/tryCatch';
import { ResponseUserType } from 'src/models/Account/User';

export const anonymizeFullstoryIdentity = (): void => {
  if (deCommonCurrentPartnerSelector(store.getState()).EnableFullStory) {
    tryCatch(() => {
      window.FS?.anonymize();
    }, "couldn't anonymize fullstory user");
  }
};

export const identifyFullstory = (data: ResponseUserType | null): void => {
  if (
    process.env.NODE_ENV === 'production' &&
    data != null &&
    data.IsAuthenticated &&
    deCommonCurrentPartnerSelector(store.getState()).EnableFullStory
  ) {
    tryCatch(() => {
      const userVars: Record<string, unknown> = {
        displayName: `${data.FirstName} ${data.LastName}`,
        email: data.Email,
        createdDate: data.CreatedDate != null ? new Date(data.CreatedDate) : '',
        firstLoginDate: data.FirstLoginDate != null ? new Date(data.FirstLoginDate) : '',
      };
      if (data.UserGroup != null) {
        userVars.userGroup = data.UserGroup;
      }
      window.FS?.identify(data.Email ? data.Email : '', userVars);
    }, "couldn't identify fullstory user");
  }
};
